new MutationObserver(() => {
    runAccessibilityFixes();
}).observe(document.body, { childList: true, subtree: true });

runAccessibilityFixes();

function runAccessibilityFixes() {
    document.querySelectorAll('li').forEach(el => {
        if (el.getAttribute('role') === 'presentation') {
            el.removeAttribute('tabindex')
        }
    })

    document.querySelectorAll('img').forEach(el => {
        if (!el.hasAttribute('alt')) {
            el.setAttribute('alt', '')
        }
    })

    document.querySelectorAll('.banner-iframe-close').forEach(el => {
        // Ensure aria-label is always set
        if (!el.hasAttribute('aria-label')) {
            el.setAttribute('aria-label', 'Close Banner')
        }

        // Ensure role is set
        if (!el.hasAttribute('role')) {
            el.setAttribute('role', 'button')
        }

        // Always ensure tabindex is set (even if role already exists)
        if (!el.hasAttribute('tabindex')) {
            // Use tabindex="1" to ensure it comes before the iframe which also has tabindex="1"
            // but is later in DOM order
            el.setAttribute('tabindex', '1')
        }

        // Move the parent dialog to the top of the DOM for better accessibility
        const dialog = el.closest('[role="dialog"]')
        if (dialog && !dialog.dataset.domMoved) {
            dialog.dataset.domMoved = 'true'
            // Move dialog to be first child of body
            document.body.insertBefore(dialog, document.body.firstChild)
        }

        // Add keyboard event handler if not already added
        if (!el.dataset.keyboardEnabled) {
            el.dataset.keyboardEnabled = 'true'
            el.addEventListener('keydown', (event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault()
                    el.click()
                }
            })
        }
    })
}